import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'

import Modal from './Modal'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import ModalFooter from './ModalFooter'

import { List } from 'immutable'

import {
    hideModalSelectorFromList,
    updateModalSelectorFilterTerm,
    getDataFromUrl,
    clearPagesModalSelector
} from '../../actions/common'

import { addTitleIfOverflow } from '../../utils/helpers'

const WAIT_INTERVAL = 1500
const ENTER_KEY = 13

class ModalSelectorFromList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            value: props.modalSelector.get('filter')
        }
    }

    handleCloseModal = (e) => {
        
        const modal = document.getElementById('modalSelectorFromList')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalSelectorFromList .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => {
            this.props.hideModalSelectorFromList(false)
            this.setState({ value: '' })
        }, 300)
    }

    handleSelectFromSelector = (e, obj) => {
        this.props.modalSelector.get('action')(obj)
        this.setState({ value: '' })
        this.props.hideModalSelectorFromList()
    }

    handleOnScroll = (e) => {
        const page = this.props.modalSelector.get('data').count() / 100
        if (page >= 1) {
            const table = ReactDOM.findDOMNode(this.table)
            const tableHeight = table.clientHeight - 297
            const scrollTop = e.target.scrollTop
            if (scrollTop >= (tableHeight * 0.8)) {
                const loadPage = Math.floor(page) + 1
                this.props.getDataFromUrl(loadPage)
            }
        }
    }

    handleOnChange = (value) => {
        clearTimeout(this.timer)
        this.setState({ value })
        this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
    }

    handleOnKeyDown = (key) => {
        if (key === ENTER_KEY) {
            clearTimeout(this.timer)
            this.triggerChange()
        }
    }

    triggerChange = () => {
        this.props.clearPagesModalSelector()
        this.props.updateModalSelectorFilterTerm(this.state.value)
        this.props.getDataFromUrl(1)
    }

    render() {
        const { modalSelector } = this.props
        if (modalSelector.get('show') === false) {
            return null
        }
       
        return (
            <Modal id="modalSelectorFromList" show={ true } ZIndex={ 2001 }>
                <ModalHeader title={ modalSelector.get('title') } onClose={ (e) => this.handleCloseModal(e, "modalSelectorFromList") } />
                <ModalBody>
                    <div style={{ width: '400px' }}>
                        <div className="row">
                            <div className="col-lg-12">
                                <div style={{ marginBottom: '10px' }}>
                                    <input className="form-control input-sm" type="text" value={ this.state.value } onChange={ (e) => this.handleOnChange(e.target.value) } onKeyDown={ (e) => this.handleOnKeyDown(e.keyCode) } placeholder="Busqueda..." />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div style={{ display: 'flex', justifyContent: 'center', height: '300px', overflowX: 'hidden', marginBottom: '20px', border: '1px solid #ddd' }} onScroll={ (e) => this.handleOnScroll(e) }>
                                    <table ref={ (ref) => this.table = ref } className="table table-bordered table-condensed table-striped table-hover nowrap" style={{ marginBottom: 0 }}>
                                        <thead>
                                            <tr>
                                                {
                                                    modalSelector.get('fields').map((x, n) => {
                                                        return (
                                                            <th width={ `${x.get('width')}` } key={ `th4[${n}]` }>{ x.get('caption') }</th>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                (modalSelector.get('data').count() > 0) ? (modalSelector.get('data') || List([]))
                                                .filter(x => {
                                                    if (modalSelector.get('filter')) {
                                                        let compare = false
                                                        modalSelector.get('fields').forEach(y => {
                                                            compare =  compare || (x.get(`${y.get('value')}`).toLowerCase().indexOf(modalSelector.get('filter').toLowerCase()) > -1)
                                                        })
                                                        return compare
                                                    } else {
                                                        return true
                                                    }
                                                })
                                                .map((x, n) => {
                                                    const tds = modalSelector.get('fields').map((y, n1) => {
                                                        return (
                                                            <td key={ `td4[${n}][${n1}]` } onMouseEnter={ e => addTitleIfOverflow(e.target) }>{ x.get(y.get('value')) }</td>
                                                        )
                                                    })
                                                    return (
                                                        <tr key={ `tr4[${n}]` } style={{ cursor: 'pointer' }} onClick={ (e) => { this.handleSelectFromSelector(e, x.toJS()) } }>
                                                            { tds }
                                                        </tr>
                                                    )
                                                }) : <tr>
                                                        <td colSpan={ modalSelector.get('fields').count() } style={{ textAlign: 'center' }}>
                                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '270px' }}>
                                                                <span></span>
                                                                <span><FontAwesome name="refresh" spin size='3x' /></span>
                                                                <span></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalSelector: state.common.get('modalSelector')
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        hideModalSelectorFromList: () => dispatch(hideModalSelectorFromList()),
        updateModalSelectorFilterTerm: (term) => dispatch(updateModalSelectorFilterTerm(term)),
        getDataFromUrl: (page) => dispatch(getDataFromUrl(page)),
        clearPagesModalSelector: () => dispatch(clearPagesModalSelector()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSelectorFromList)


// WEBPACK FOOTER //
// ./src/components/Shared/ModalSelectorFromList.jsx